var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "10.803mm",
    height: "8.562mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 10803 8562",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M10197.1 7601.5l-1304.4 0 0 -222.3 1304.4 0.1c0.7,-0.3 1.7,-0.3 2.5,-0.3 211.8,0 383.6,-171.8 383.6,-383.6 0,0 0,0 0,0l0.2 -5045.4c-0.2,-211.8 -172,-383.6 -383.8,-383.6l-9591 0c-0.8,0 -1.8,0 -2.6,0 -211.8,0 -383.6,171.8 -383.6,383.6 0,0 0,0 0,0l-0.1 5045.6c0.1,-0.2 0.1,-0.2 0.1,-0.2 0,211.8 171.8,383.6 383.6,383.6 0.8,0 1.8,0 2.6,0l1322.9 0.3 0 222.3 -1322.9 -0.1c0.1,-0.2 0.1,-0.2 0.1,-0.2 -335,0 -607.1,-270.9 -608.5,-605.8l-0.2 -5045.5c1.6,-334.9 273.7,-605.8 608.7,-605.8 0,0 0,0 0,0l9588.4 -0.1c333.9,1.5 604.3,271.9 605.7,605.9l0.2 5045.6c-1.6,333.9 -272,604.3 -606,605.7l0.1 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M8972.1 8562l-7143.8 0 0 -4394.8 7143.8 0 0 4394.8zm-6916.3 -222.3l6694 0 0 -3950.2 -6694 0 0 3950.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M8487.9 1558.4l-6172.8 0 0 -1558.4 6172.8 0 0 1558.4zm-5947.9 -222.2l5725.6 0 0 -1113.9 -5725.6 0 0 1113.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M9403.3 3397.3c-0.9,0 -1.8,0 -2.7,0 -360.9,0 -653.5,-292.6 -653.5,-653.5 0,-360.9 292.6,-653.5 653.5,-653.5 360.9,0 653.5,292.6 653.5,653.5 0,0 0,0 0,0 0,359.8 -291,652.1 -650.9,653.5l0.1 0zm0 -1082.2c-0.9,0 -1.9,0 -2.7,0 -238.2,0 -431.3,193.1 -431.3,431.3 0,238.2 193.1,431.3 431.3,431.3 238.2,0 431.3,-193.1 431.3,-431.3 0,-0.8 0,-1.8 0,-2.6 -1.4,-236.1 -192.6,-427.3 -428.7,-428.7l0.1 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2585,
    y: 5241.5,
    width: 5066.8,
    height: 222.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2585,
    y: 6254.8,
    width: 3159.1,
    height: 222.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2585,
    y: 7265.5,
    width: 4410.6,
    height: 222.2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc34);
export default __webpack_public_path__ + "static/media/ic_3_4.7660b660f9de17b19ac55497e41ba747.svg";
export { ForwardRef as ReactComponent };